import axios from "../axios";

const loginUser = (payload) => axios.post("users/login", payload);

const fetchCustomerData = (id) => axios.get(`users/${id}`);

const getNewAccessToken = (payload) =>
  axios.post("users/refresh-token", payload);
const googleLogin = (code) => axios.post("/users/google-login", { code });

const registerUser = (payload) => axios.post("/users/register", payload);

const resetPassword = (payload) =>
  axios.post("/users/change-password", payload);
const forgotPassword = (payload) =>
  axios.post("/users/forgot-password", payload);

const resendVerificationEmail = (payload) =>
  axios.post("/users/send-verification-mail", payload);

const verifyEmail = (payload) => axios.post("/users/verify-email", payload);

const sendOtP = (payload) => axios.post("/users/send-otp", payload);

const verifyOtp = (payload) => axios.post("/users/verify-otp", payload);

const updateUser = (payload, id) => axios.post(`/users/${id}`, payload);

const updatePersonalInfo = (payload, id) =>
  axios.post(`/users/${id}/update-user-info`, payload);

const updatePremiumInfo = (payload, id) =>
  axios.post(`/users/${id}/update-premium-info`, payload);

const initiatePayment = (payload) =>
  axios.post(`/users/initiate-payment`, payload);

const updateBusinessInfo = (payload, id) =>
  axios.post(`/users/${id}/update-business-info`, payload);

const fetchUser = (id) => axios.get(`/users/${id}`);

const refreshToken = (refresh_token) =>
  axios.post("/users/refresh-token", refresh_token);

const avatarUpload = (payload, id) =>
  axios.post(`/users/${id}/upload-avatar`, payload);

const getAvatarUploadUrl = (payload, id) =>
  axios.post(`/users/${id}/get-avatar-upload-url`, payload);

const uploadAvatarRecord = (payload, id) =>
  axios.post(`/users/${id}/upload-avatar`, payload);

const logoutUser = () => axios.post("/users/logout");

const downloadInvoice = (transactionId) =>
  axios.get(`/users/invoice/${transactionId}/download`, {
    responseType: "blob",
  });

const cancelSubscription = () => axios.post("/users/cancel-subscription");

const changeSubscriptionPlan = (payload) =>
  axios.post("/users/change-subscription-plan", payload);

const getPaymentMethodUpdateUrl = () =>
  axios.get("/users/payment-method-update-url");

const getBillingStatus = () => axios.get("/users/billing-status");

const getTransactions = (params) =>
  axios.get("/users/transactions", {
    params,
  });

const resumeSubscription = () => axios.post("/users/resume-subscription");

const cancelPendingPlanChange = () =>
  axios.post("/users/cancel-pending-plan-change");

export const getTransactionStatus = (transactionId) => {
  return axios.get(`/users/transaction-status/${transactionId}`);
};

export {
  loginUser,
  fetchCustomerData,
  getNewAccessToken,
  googleLogin,
  registerUser,
  resetPassword,
  forgotPassword,
  resendVerificationEmail,
  verifyEmail,
  sendOtP,
  verifyOtp,
  updateUser,
  updatePersonalInfo,
  updatePremiumInfo,
  initiatePayment,
  updateBusinessInfo,
  fetchUser,
  refreshToken,
  avatarUpload,
  getAvatarUploadUrl,
  uploadAvatarRecord,
  logoutUser,
  downloadInvoice,
  cancelSubscription,
  changeSubscriptionPlan,
  getPaymentMethodUpdateUrl,
  getBillingStatus,
  getTransactions,
  resumeSubscription,
  cancelPendingPlanChange,
};
